//This file contains functions for use when rendering DOM elements
//on the resume page of the website.

import getData from './locol-request';

//These function format lines taken from the data file.  For each
//line of the form (key) - (value), they take the value data as
//input.

//This function handles the Name key.
const showAsName = (text) => {
    const h1Tag = document.createElement("h1");
    h1Tag.innerHTML = text;
    document.querySelector("#resume").appendChild(h1Tag);
}
//This function handles the Address key.
const showAsAddress = (text) => {
    const h2Tag = document.createElement("h2");
    h2Tag.innerHTML = text;
    document.querySelector("#resume").appendChild(h2Tag);
}

//This function handles the Email key.
const showAsEmail = (text) => {
    const h2Tag = document.createElement("h2");
    const aTag = document.createElement("a");
    aTag.setAttribute("href", "mailto:" + text);
    aTag.textContent = text;
    h2Tag.appendChild(aTag);
    document.querySelector("#resume").appendChild(h2Tag);
}

//This function handles the Section key.
const showAsSection = (text) => {
    const pTag = document.createElement("p");
    pTag.classList.add("resume-section");
    pTag.innerHTML = text;
    document.querySelector("#resume").appendChild(pTag);
}

//This function handles the Paragraph key.
const showAsParagraph = (text) => {
    const pTag = document.createElement("p");
    pTag.innerHTML = text;
    document.querySelector("#resume").appendChild(pTag);
}

//This function handles the Flex key.
const showAsFlex = (text) => {
    const flexTag = document.createElement("div");
    flexTag.classList.add("flex");
    
    //The flex items are in the parameter, seperated by semicolons.
    const flexItemArray = text.split(";");
    flexItemArray.forEach((item) => {
        const innerPTag = document.createElement("p");
        innerPTag.innerHTML = item.trim();
        flexTag.appendChild(innerPTag);
    });

    document.querySelector("#resume").appendChild(flexTag);
}

//This function handles the Title key.
const showAsTitle = (text) => {
    const pTag = document.createElement("p");
    pTag.classList.add("block-highlight");
    pTag.innerHTML = text;
    document.querySelector("#resume").appendChild(pTag);
}

//This function handles the List key.
const showAsList = (text) => {
    const listTag = document.createElement("ul");
    
    //The list items are in the parameter, seperated by semicolons.
    const listItemArray = text.split(";");
    listItemArray.forEach((item) => {
        const innerLiTag = document.createElement("li");
        innerLiTag.innerHTML = item.trim();
        listTag.appendChild(innerLiTag);
    });

    document.querySelector("#resume").appendChild(listTag);
}

//This function handles the Note key.
const showAsNote = (text) => {
    const pTag = document.createElement("p");
    pTag.classList.add("note");
    pTag.innerHTML = text;
    document.querySelector("#resume").appendChild(pTag);
}

//END of line-formatting functions.

//Function to load the resume.
export const loadResume = async () => {
    //Get the page div that will hold the resume.
    const containerDiv = document.querySelector('#resume');

    try {
        //Retrieve the resume.  Note that this is why a try-catch
        //block is needed.
        const rawData = await getData('./data/resume-data.txt');

        //Split the resume into lines.
        const dataArray = rawData.split('\n');

        //Loop through each line of the resume file.  Each line is 
        //of the form (key) - (data) where the key indicates how
        //the data is to be formatted.  The keys are Name, Address,
        //Email, Section, Paragraph, Flex, Title, List, and Note. 
        dataArray.forEach((line) => {
            //Split line into key and data.
            const dashIndex = line.indexOf("-");
            const key = line.substring(0, dashIndex).trim();
            const value = line.substring(dashIndex + 1).trim();

            //Use helper functions to format each type of line.
            switch (key) {
                case "Name":
                    showAsName(value);
                    break;
                case "Address":
                    showAsAddress(value);
                    break;
                case "Email":
                    showAsEmail(value);
                    break;
                case "Section":
                    showAsSection(value);
                    break;
                case "Paragraph":
                    showAsParagraph(value);
                    break;
                case "Flex":
                    showAsFlex(value);
                    break;
                case "Title":
                    showAsTitle(value);
                    break;
                case "List":
                    showAsList(value);
                    break;
                default:  //"Note"
                    showAsNote(value);
            }
        });
    } catch (error) {
        //Show error message if the resume was not retrieved.
        containerDiv.innerHTML = 'ERROR!  ' + error; 
    }
}